import PropTypes from 'prop-types';

// material-ui
import { Tooltip, Typography, Box } from '@mui/material';

// third-party
import { format } from 'date-fns';
import { useIntl } from 'react-intl';

// ==============================|| RENDER GENERIC GRID CELL ||============================== //

const RenderGridCell = ({ value, type = 'string' }) => {
    const intl = useIntl();

    if (!value) return <Box />;

    let tooltipText;
    let cellText;

    switch (type) {
        case 'date':
        case 'dateTime':
            tooltipText = format(new Date(value), 'd/MM/yyyy HH:mm');
            cellText = format(new Date(value), 'd/MM/yyyy HH:mm');
            break;
        case 'boolean':
            tooltipText = intl.formatMessage({ id: `ui-comp-form-boolean-${value}` });
            cellText = intl.formatMessage({ id: `ui-comp-form-boolean-${value}` });
            break;
        default:
            tooltipText = value;
            cellText = value;
    }

    return tooltipText && cellText ? (
        <Tooltip title={tooltipText}>
            <Typography color="inherit" variant="inherit">
                {cellText}
            </Typography>
        </Tooltip>
    ) : (
        <Box />
    );
};

RenderGridCell.propTypes = {
    value: PropTypes.any,
    type: PropTypes.string
};

export default RenderGridCell;
